export const homeCopy = {
  hero: {
    headline: 'Great software starts with great people.',
    subhead:
      "We're a young team of experienced developers and designers who build web platforms, mobile apps, and digital products that actually work.",
    mobileSubhead:
      "We're a young team of experienced developers and designers who build web platforms, mobile apps, and digital products that actually work.",
    chips: [
      'Senior-led delivery: architecture, DevOps & code quality',
      'Competitive rates: transparent & fair',
      'Ember specialists: 10+ years in production',
      'React experience: complex frontends at scale',
      'Security-first: enterprise practices',
    ],
    ctas: {
      primary: { label: 'Book a call', href: '#contact' },
      secondary: { label: 'See our work', href: '#success' },
    },
    availability:
      "Have a sprint coming up? Let's chat.",
  },
  about:
    "We're a small group of engineers, designers, and makers who love solving real-world problems. We've built products together for years, and it shows in how we work.",
  servicesIntro:
    "We help startups and growing companies build, improve, and scale their products. Work with us as part of your team or as your full dev squad.",
  caseStudies: [
    {
      title: 'ID Plans (USA)',
      techStack: ['React', 'Nest.js'],
      body: 'Refactored and modernized a legacy Ember app.',
      result: '40% faster load times, 99.9% uptime, happier dev team.',
    },
    {
      title: 'Feldico (Argentina)',
      techStack: ['Ember.js', 'PostgresSQL'],
      body: 'Full-stack web platform connecting thousands of farmers and contractors.',
      result: 'Built from scratch using Ember + PostGIS. Nationwide adoption. Continuous partnership.',
    },
  ],
  technologies: [
    'TypeScript',
    'Ember',
    'React',
    'Node/Express/Nest',
    'Next',
    'Postgres',
    'Redis',
    'Elasticsearch',
    'Jest/Vitest',
    'Playwright',
    'Docker',
    'CI/CD',
  ],
  testimonials: [
    {
      quote:
        'Madow Tech feels like an extension of our team. Fast, sharp, and communicative.',
      author: 'Erik L., CTO @ ID Plans',
    },
    {
      quote:
        'They delivered exactly what we needed. Reliable and proactive from day one.',
      author: 'S. Gómez, Founder @ Feldico',
    },
    {
      quote:
        'Working with this team has been refreshing. They understand the problem, propose solutions, and execute without drama.',
      author: 'Tech Lead, Confidential Fintech',
    },
  ],
  ratesBanner: {
    line1:
      'Senior LATAM talent. Competitive rates. Custom proposals in 48 hours.',
    cta: { label: 'Request rates & availability', href: '#contact' },
  },
  teamIntro:
    "We've built products together for years, and it shows in how we work.",
  footerCta:
    "Let's build something great together. Tell us about your project or idea. We'll get back within a day.",
};
